import React from 'react';
import PropTypes from 'prop-types';

import './style.css';

const LegendChoropleth = (props) => {
  const { items } = props;

  if (!items || !items.length) return null;

  return (
    <ul className="c-legend-type-choropleth">
      {items.map(({ name, value, color }) => (
        <li key={`legend-choropleth-item-${name}`}>
          <div className="icon-choropleth" style={{ backgroundColor: color }} />
          <span className="name">
            {value}
          </span>
        </li>
      ))}
    </ul>
  );
};

LegendChoropleth.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }))
};

LegendChoropleth.defaultProps = {
  items: [
    {
      name: '0 h',
      color: '#FFFFFF'
    }, {
      color: '#C0F09C',
      name: '1 h'
    }, {
      color: '#E3DA64',
      name: '2 h'
    }, {
      color: '#D16638',
      name: '3 h'
    }, {
      color: '#BA2D2F',
      name: '6 h'
    }, {
      color: '#A11F4A',
      name: '12 h'
    }, {
      color: '#730D6F',
      name: '1 d'
    }, {
      color: '#0D0437',
      name: '14 d'
    }, {
      color: '#00030F',
      name: '1 m'
    }
  ]
};

export default LegendChoropleth;



// WEBPACK FOOTER //
// ./src/components/legend/legend-choropleth/index.js